<template>
  <div class="overlay"></div>
  <div class="modal-container card-elevated">
    <div class="card-header">
      <div class="header-text">Invite external user to {{ name }} on {{ date }}</div>
      <span class="material-symbols-outlined close" @click="$emit('close-modal')">close</span>
    </div>
    <div class="modal-body">
      <form ref="inviteForm" @submit.prevent="handleSend">
        <div class="button-container">
          <input type="text" class="text-input" placeholder="First Name" v-model="firstName" required>
          <input type="text" class="text-input" placeholder="Last Name" v-model="lastName" required>
        </div>
        <div class="button-container">
          <div class="email-container">
            <input for="email" type="email" class="text-input" placeholder="User Email" v-model="email"
              @blur="validateEmail" required>
          </div>
          <button type="submit" class="primary-outlined-button">Send</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2024 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { defineEmits, defineProps, ref } from 'vue'

defineProps({
  name: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['close-modal', 'send-external-invite'])

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const inviteForm = ref(null)
const emailError = ref(false)

const handleSend = () => {
  if (inviteForm.value.checkValidity()) {
    emit('send-external-invite', {
      name: `${firstName.value} ${lastName.value}`,
      email: email.value,
    })
  } else {
    emailError.value = true
  }
}
</script>

<style scoped lang="scss">
input:hover {
  cursor: text;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 999;
}

.modal-container {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 10rem;
  z-index: 1000;
  background-color: var(--White);
  color: var(--Black);
  width: 40vw;
  margin: auto;
}

.header-text {
  font-size: 1rem;
  color: var(--Grey800);
}

.modal-body {
  padding: 20px;
}

.close {
  cursor: pointer;
}

.description {
  font-size: 1.1rem;
  font-weight: 500;
  margin: 10px auto 20px 0;
  text-align: left;

  &span {
    font-weight: 900;
  }
}

.button-container {
  margin: 2rem 0;
  gap: 1rem;
}

.button-container>input {
  width: 75%;
  margin-bottom: 0;
}

.button-container>button {
  margin-right: 0;
  width: 25%;
}

.email-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  span {
    margin-right: auto;
  }
}

.error {
  color: var(--ErrorRedDark)
}
</style>
